{
	"id": 7507,
	"moduleNumber": 7,
	"slug": "module-7",
	"kgNodeId": "module-7",
	"title": "The Professional Educator and AI",
	"subtitle": "Use AI responsibly by maintaining oversight, protecting privacy, ensuring transparency, and prioritizing student welfare.",
	"type": "simulation",
	"moduleKind": "ai_simulation",
	"moduleKindLabel": "AI Simulation",
	"sourceStatus": "extracted_from_editorial_and_scenario_assets",
	"summary": "Module 7 introduces AI-related educator ethics through three simulation scenarios: data privacy, human-in-the-loop decision making, and social media. Learners evaluate how professional responsibilities apply when AI tools influence student data, instructional decisions, and educator communication.",
	"estimatedDurationMinutes": 50,
	"activityCount": 3,
	"knowledgeCheck": {
		"included": false,
		"questionCount": 0
	},
	"learningObjectives": [
		"Recognize ethical risks when AI systems use student or school data.",
		"Explain why educators remain accountable for professional judgment when using AI-assisted tools.",
		"Apply privacy, transparency, and student-welfare principles to AI and social media scenarios."
	],
	"flow": [
		"Module introduction: The Professional Educator and AI.",
		"Simulation 1: Data Privacy.",
		"Simulation 2: Human in the Loop.",
		"Simulation 3: Social Media.",
		"Reflection on ethical principles and educator responsibilities."
	],
	"scenarios": [
		{
			"id": "module-7-data-privacy",
			"title": "AI and Data Privacy",
			"summary": "Learners evaluate whether student or school data can be used responsibly in AI-assisted tools and what safeguards are needed."
		},
		{
			"id": "module-7-human-in-the-loop",
			"title": "AI: Human in the Loop",
			"summary": "Learners consider when educators must review, override, or contextualize AI-generated recommendations before acting."
		},
		{
			"id": "module-7-social-media",
			"title": "AI and Social Media",
			"summary": "Learners apply professional boundaries, transparency, and public-trust principles to AI-assisted social media communication."
		}
	],
	"ethicalSituations": ["Data Privacy", "Human in the Loop", "Social Media"],
	"aiTopics": [
		"Student data privacy",
		"Human oversight",
		"AI-assisted communication",
		"Professional accountability"
	],
	"sources": {
		"curriculum": "../../../../.working/Praxis ProEthics/Content/curriculum/modules/module-7/module.md",
		"primary": "../../../../.working/Praxis ProEthics/Content/Module 7/Module 7_The Professional Educator and AI.docx",
		"editorial": "../../../../.working/Praxis ProEthics/Content/Module 7/AD Edit Module 7_The Professional Educator and AI.docx",
		"scenarios": ["Data Privacy", "Human-In-The-Loop", "Social Media"],
		"personas": [
			"Ms. Daria, student teacher using ChatGPT to grade student essays",
			"Mr. Dennis, teacher using AI to generate homework assignments",
			"Mr. Smith, parent of a student who used AI to create and circulate a harmful social-media video"
		],
		"transcripts": [],
		"videos": []
	}
}
